import React from 'react';
import { Formik, Form } from 'formik';
import { Button as DButton, useTreatmentForm } from '@futurefamily/ef-components';
import styled from 'styled-components';
import routes from 'constants/routes';
import { treatments } from 'constants/treatments';
import TreatmentSelect from './TreatmentSelect';
import Addons from './Addons';

function validate (values) {
  const errors = {};

  if (!values.treatment) {
    errors.treatment = 'Please select a treatment';
  }

  return errors;
}

const Wrapper = styled.div`
  background-color: var(--teal);
  color: var(--white);
  display: flex;
  flex-direction: column;
  min-width: var(--container-size);
`

const Button = styled(DButton)`
  background-color: var(--dark-blue);
`


export function TreatmentForm () {
  const { initialValues, onSubmit } = useTreatmentForm(routes, treatments);

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit} validate={validate}>
      {formProps => (
        <Form role="form">
          <Wrapper className="p-5 container">
            <div className="row mb-5">
              <TreatmentSelect />
              <Addons />
            </div>
            <div className="row">
              <div className="col col-md-4 offset-md-4 d-flex justify-content-center">
                <Button type="submit">SEE MY OPTIONS</Button>
              </div>
            </div>
          </Wrapper>
        </Form>
      )}
    </Formik>
  );
}

export default TreatmentForm;
